import React from 'react';
import { StyledWrapperStepContent } from './index.style';
import ActionsHeader from '../VoiceSampleUploader/ActionsHeader';

const WrapperStepContent = ({ children, onSetStep }) => (
  <StyledWrapperStepContent>
    <ActionsHeader onSetStep={onSetStep} />
    {children}
  </StyledWrapperStepContent>
);

export default WrapperStepContent;
